export default () => {
  const appBannerVisible = "js-app-banner";
  const noneTransform = "none-transform";
  const body = document.querySelector("body");
  const header = document.querySelector(".layout__header");
  const appBannerLayout = document.querySelector(".app-banner");
  const mobileMenuTriggerButton = document.querySelector(".mobile-menu-trigger-button");

  const appBannerGlobal = () => {
    const headerFixed = () => {
      if (appBannerLayout) {
        var offsetTop = window.pageYOffset;
        var appBannerHeight = appBannerLayout.clientHeight;

        if(offsetTop < appBannerHeight) {
          mobileMenuTriggerButton.addEventListener("click", movingHeader);
          header.classList.remove(noneTransform);
        } else {
          mobileMenuTriggerButton.addEventListener("click", movingHeader);
          header.classList.add(noneTransform);
        }
      }
    };
    headerFixed();

    // window.addEventListener("load", () => headerFixed());
    window.addEventListener("resize", () => {
      header.removeAttribute("style");
      headerFixed()
    });
  };

  const movingHeader = () => {
    var scrollPosition = window.scrollY;
    var appBannerHeight = appBannerLayout.clientHeight;
    var scrollTop = appBannerHeight - scrollPosition;

    if (header.hasAttribute("style") || body.classList.contains(appBannerVisible)){
      header.removeAttribute("style");
    } else {
      header.style.marginTop = `-${scrollTop}px`;
    }
    body.classList.toggle(appBannerVisible);
  };

  if(appBannerLayout) {
    appBannerGlobal();
  }
}
